import { cn } from '@/lib/utils';

export interface GuideStep {
  title: string;
  titleTone?: 'default' | 'danger';
  detail?: string;
  detailTone?: 'muted' | 'danger';
  href?: string;       // 있으면 스텝 하단에 새 탭 링크 버튼 노출(예: KB 인터넷뱅킹)
  linkLabel?: string;  // 링크 버튼 텍스트
}

export function Eyebrow({ children }: { children: React.ReactNode }) {
  return (
    <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-400">
      {children}
    </p>
  );
}

export function NumberRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-xl bg-white px-4 py-3 ring-1 ring-slate-200">
      <p className="text-xs text-slate-400">{label}</p>
      <p className="font-mono text-base font-semibold tracking-tight text-slate-900 tabular-nums">
        {value}
      </p>
    </div>
  );
}

export function GuideSteps({ steps, startAt }: { steps: GuideStep[]; startAt: number }) {
  return (
    <ol className="relative space-y-3.5 pl-1">
      {steps.map((step, index) => {
        const isLast = index === steps.length - 1;
        return (
          <li key={step.title} className="relative flex gap-3">
            {!isLast && (
              <span
                className="absolute left-[11px] top-6 h-[calc(100%-4px)] w-px bg-slate-200"
                aria-hidden
              />
            )}
            <span className="z-10 flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-slate-900 text-[11px] font-semibold text-white tabular-nums">
              {startAt + index}
            </span>
            <div className="pt-px">
              <p className={cn(
                'text-sm leading-snug',
                step.titleTone === 'danger'
                  ? 'font-semibold text-rose-600'
                  : 'text-slate-700',
              )}>
                {step.title}
              </p>
              {step.detail && (
                <p className={cn(
                  'mt-0.5 text-xs',
                  step.detailTone === 'danger'
                    ? 'font-semibold text-rose-600'
                    : 'text-slate-400',
                )}>
                  {step.detail}
                </p>
              )}
              {step.href && (
                <a
                  href={step.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-1.5 inline-flex items-center gap-1 rounded-lg bg-slate-900 px-2.5 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-slate-700"
                >
                  {step.linkLabel ?? '바로가기'}
                  <span aria-hidden>↗</span>
                </a>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
